"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.play = void 0;
exports.play = {
    path: "M14.5833 9.99996L5.41666 15.8333V4.16663L14.5833 9.99996ZM11.475 9.99996L7.08332 7.19996V12.8L11.475 9.99996Z",
    originalWidth: 20,
    originalHeight: 20,
    basicColor: "tableGray1",
    activeColor: "tableBlack2"
};
